import TextareaAutosize from 'react-textarea-autosize'

const AutoSizeTextArea = TextareaAutosize

export default AutoSizeTextArea
